import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function ComponentIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.4 3.07981L8.4 0.0751174C8.1 -0.0250391 7.9 -0.0250391 7.6 0.0751174L0.6 3.07981C0.2 3.17997 0 3.58059 0 3.98122V11.9937C0 12.3944 0.2 12.795 0.6 12.8951L7.6 15.8998C7.7 16 7.9 16 8 16C8.1 16 8.3 16 8.4 15.8998L15.4 12.8951C15.8 12.6948 16 12.3944 16 11.9937V3.98122C16 3.58059 15.8 3.17997 15.4 3.07981ZM8 2.07825L12.5 3.98122L8 5.88419L3.5 3.98122L8 2.07825ZM2 5.48357L7 7.58685V13.3959L2 11.2926V5.48357ZM9 13.4961V7.68701L14 5.58372V11.3928L9 13.4961Z" />
      </svg>
    </Icon>
  );
}
